import { render, staticRenderFns } from "./AppManifest.vue?vue&type=template&id=35644c2e&scoped=true&"
var script = {}
import style0 from "./AppManifest.vue?vue&type=style&index=0&id=35644c2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35644c2e",
  null
  
)

export default component.exports